import {NavigationContainer, NavigationContainerRef} from '@react-navigation/native';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import React, {useRef, useState} from 'react';
import AccountScreen from './AccountScreen';
import AuthenicationStack from './Authentication/AuthenticationStack';
import HomeStackNavigator from './Home/HomeStack';
import {useAuth} from '../Utils/AuthProvider';
import AppUpdateHandler from '../Components/AppUpdateHandler';
import WebBackButtonHandler from '../Components/WebBackButtonHandler';

export type AppStackNavigationParms = {
  Authentication: undefined;
  HomeStack: undefined;
  Account?: {
    id: string | undefined;
  };
};

const Stack = createNativeStackNavigator<AppStackNavigationParms>();

export default function AppNavigation() {
  const {appSession} = useAuth();
  const navigationRef = useRef<NavigationContainerRef<any>>(null);
  const [navigationState, setNavigationState] = useState<any>(null);

  const handleStateChange = (state: any) => {
    setNavigationState(state);
  };

  return (
    <>
      <NavigationContainer 
        ref={navigationRef}
        onStateChange={handleStateChange}
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            animation: 'slide_from_left',
          }}>
          {!appSession?.user ? (
            <Stack.Screen
              name="Authentication"
              component={AuthenicationStack}
            />
          ) : (
            <>
              <Stack.Screen name="HomeStack" component={HomeStackNavigator} />
              <Stack.Screen name="Account" component={AccountScreen} />
            </>
          )}
        </Stack.Navigator>
      </NavigationContainer>
      <WebBackButtonHandler 
        navigationRef={navigationRef} 
        onStateChange={handleStateChange}
      />
      <AppUpdateHandler />
    </>
  );
}
